module.exports = __webpack_public_path__ + "static/img/servicios.08910b31.jpg";